import * as actionTypes from './snackbarActions';

const initialState = {
    action: false,
    open: false,
    message: 'Note archived',
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
    },
    variant: 'default',
    alert: {
        color: 'primary',
        variant: 'filled'
    },
    transition: 'Fade',
    close: true,
    actionButton: false
};

const snackbarReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CLOSE_SNACKBAR:
            return {
                ...state,
                open: false
            };
        case actionTypes.OPEN_SNACKBAR:
            const { open, message, anchorOrigin, variant, alert, transition, close, actionButton } = action.action;
            return {
                ...state,
                action: !state.action,
                open: open || initialState.open,
                message: message || initialState.message,
                anchorOrigin: anchorOrigin || initialState.anchorOrigin,
                variant: variant || initialState.variant,
                alert: {
                    color: alert?.color || initialState.alert.color,
                    variant: alert?.variant || initialState.alert.variant
                },
                transition: transition || initialState.transition,
                close: close === false ? close : initialState.close,
                actionButton: actionButton || initialState.actionButton
            };
        default:
            return state;
    }
};

export default snackbarReducer;
